module.exports = __webpack_public_path__ + "static/media/graphic-off.3b86639f.png";